import { DocumentFragments } from '@/apollo/fragments/document';
import { Field } from '@/form/decorators/Field';
import { Form } from '@/form/decorators/Form';
import GraphQLForm from '@/form/GraphQLForm';
import { IDocument, MeetAndGreetTermsDocument } from '@/types/api';
import gql from 'graphql-tag';
import { DocumentForm } from '.';

@Form({
  apollo: {
    mutation: gql`
      mutation UpdateMeetAndGreetTerms($input: UpdateMeetAndGreetTermsInput!) {
        updateMeetAndGreetTerms(input: $input) {
          meetAndGreetTerms {
            ...Document
          }
        }
      }
      ${DocumentFragments.Document}
    `,
    refetchQueries: ['MeetAndGreetTerms'],
  },
})
export class UpdateMeetAndGreetTermsForm extends GraphQLForm<IDocument> implements DocumentForm {
  @Field()
  public html: string;

  constructor(old: MeetAndGreetTermsDocument) {
    super();
    this.html = old.html;
  }
}
